<template>
    <Layout class="layout">
        <Headers></Headers>
        <Layout>
            <Sider hide-trigger :style="{height:($store.state.tableHight - 65) + 'px'}" class="rx-sider">
                <Side></Side>
            </Sider>
            <Layout class="zc-main">
                <Content class="zc-body" :style="{height:($store.state.tableHight - 105) + 'px'}">
                    <Row :gutter="16" >
                        <Col span="6" >
                            <div class="rx-index-box" @click="toLink('/order/settlement')">
                                <div class="box-line">
                                    <div class="order-count text-primary">
                                        {{basic.orderCustomerWaitCount}}
                                    </div>
                                </div>
                                <div class="name">客户待结订单</div>
                                <Icon type="ios-cafe" size="26" class="icons" />
                            </div>
                        </Col>
                        <Col span="6" >
                            <div class="rx-index-box" @click="toLink('/order/settlement')">
                                <div class="box-line">
                                    <div class="order-count text-primary">
                                        {{basic.orderDriverWaitCount}}
                                    </div>
                                </div>
                                <div class="name">司机待结订单</div>
                                <Icon type="md-contacts" size="26" class="icons" />
                            </div>
                        </Col>
                        <Col span="6">
                            <div class="rx-index-box"  @click="toLink('/car/insurance')">
                                <div class="box-line">
                                    <div class="order-count text-primary">
                                        {{basic.insuranceWaitCount}}
                                    </div>
                                </div>
                                <div class="name">待处理车辆保险</div>
                                <Icon type="ios-photos" size="26" class="icons" />
                            </div>
                        </Col>
                        <Col span="6">
                            <div class="rx-index-box"  @click="toLink('/car/illegal')">
                                <div class="box-line">
                                    <div class="order-count text-primary">
                                        {{basic.illegalWaitCount}}
                                    </div>
                                </div>
                                <div class="name">待处理车辆违章</div>
                                <Icon type="ios-rose" size="26" class="icons" />
                            </div>
                        </Col>
                    </Row>
                    <Row :gutter="16">
                        <Col span="24">
                            <Card :bordered="false" class="rx-index-card" dis-hover shadow>
                                <div slot="title" class="text-primary"><Icon type="md-stats" size="16"  /> 司机提成金额统计</div>
                                <span slot="extra">
                                   <DatePicker type="month" v-model="month_date" @on-change="datepicker_change_event" format="yyyy-MM" size="small" placeholder="默认当前月" style="width: 200px"/>
                                </span>
                                <div  class="width-100" style="display: flex; align-items: center; justify-content: space-between">
                                    <div class="width-70 charts-box">
                                        <DriverEchart :date="end_date" ref="DriverEchartBox"></DriverEchart>
                                    </div>
                                    <div class="image width-30"><img style="width:100%"  src="/static/demo.png"></div>
                                </div>

                            </Card>
                        </Col>
                    </Row>

                    <Row :gutter="16">
                        <Col span="24">
                            <Card :bordered="false" class="rx-index-card" dis-hover shadow>
                                <div slot="title" class="text-primary"><Icon type="md-stats" size="16"  /> 供应商订单金额统计</div>
                                <span slot="extra">
                                   <DatePicker type="month" v-model="company_date" @on-change="datepicker_company_event" format="yyyy-MM" size="small" placeholder="默认当前月" style="width: 200px"/>
                                </span>
                                <div  class="width-100" style="display: flex; align-items: center; justify-content: space-between">
                                    <div class="width-100 charts-box">
                                        <CompanyEchart :date="company_date" ref="CompanyEchartBox"></CompanyEchart>
                                    </div>
                                </div>

                            </Card>
                        </Col>
                    </Row>
                    <Row :gutter="16">
                        <Col span="18">
                            <Card :bordered="false" class="rx-index-card" dis-hover shadow>
                                <div slot="title" class="text-primary"><Icon type="md-stats" size="16"  /> 近一年订单金额统计</div>
                                <span slot="extra">
                                   <Icon type="md-calendar" /> {{start_date}} ~ {{end_date}}
                                </span>
                                <div  class="width-100 charts-box">
                                    <OrderEchart ref="OrderEchartEchartBox"></OrderEchart>
                                </div>
                            </Card>
                        </Col>
                        <Col span="6">
                            <Card :bordered="false" class="rx-index-card" dis-hover shadow>
                                <div slot="title" class="text-primary"><Icon type="md-stats" size="16"  /> 近一年订单类型统计</div>
                                <span slot="extra">
                                   <Icon type="md-calendar" /> {{start_date}} ~ {{end_date}}
                                </span>
                                <div class="otype-list">
                                    <div class="otype-li" v-for="(item,index) in top_order_type_list" v-if="index<=9" :key="index">
                                        <div class="l">
                                            <span>{{index+1}}、</span>
                                            {{item.name}}
                                        </div>
                                        <span class="r">{{item.num}} 单</span>
                                    </div>
                                </div>
                            </Card>
                        </Col>
                    </Row>
                    <Row :gutter="16">
                        <Col span="24">
                            <Card :bordered="false" class="rx-index-card" dis-hover shadow>
                                <div slot="title" class="text-primary"><Icon type="md-stats" size="16"  /> 近一年发票金额统计</div>
                                <span slot="extra">
                                   <Icon type="md-calendar" /> {{start_date}} ~ {{end_date}}
                                </span>
                                <div  class="width-100 charts-box">
                                    <InvoiceEchart ref="InvoiceEchartBox"></InvoiceEchart>
                                </div>
                            </Card>
                        </Col>
                    </Row>

                </Content>
            </Layout>
        </Layout>
    </Layout>
</template>

<script>
import '@/assets/admin/style.css'
import Headers from "@/components/public/Headers";
import Side from "@/components/public/Side";
import OrderEchart from "@/components/echart/OrderEchart";
import InvoiceEchart from "@/components/echart/InvoiceEchart";
import DriverEchart from "@/components/echart/DriverEchart";
import CompanyEchart from "@/components/echart/CompanyEchart";

export default {
  name: 'HomeIndex',
    components: {
        Headers, Side, OrderEchart, InvoiceEchart, DriverEchart, CompanyEchart
    },
  data () {
    return {
        isCollapsed: false,
        basic: [],
        top_order_type_list:[],
        start_date:'',
        end_date:'',
        company_date:'',
        month_date: '',
    }
  },
    created(){
        this.getStatic();
        this.getStaticData();
    },
    mounted(){
        let that = this;
        this.GetOrderEchart();
        this.GetInvoiceEchart();
        this.GetDriverEchart();
        this.GetCompanyEchart();
        that.HeightInit();
    },
    computed: {
        rotateIcon () {
            return [
                'menu-icon',
                this.isCollapsed ? 'rotate-icon' : ''
            ];
        },
        menuitemClasses () {
            return [
                'menu-item',
                this.isCollapsed ? 'collapsed-menu' : ''
            ]
        }
    },
    watch: {
        // month_date(newVal, oldVal) {
        //     if (newVal !== oldVal) {
        //         this.$refs.DriverEchartBox.GetDriverEchart();
        //     }
        // }
    },
    methods: {
        //跳转指定路由
        toLink(url){
             console.log(url);
            if(!url) return;
            this.$router.push(url);
        },
        datepicker_change_event(e) {
            console.log('正常格式日期',e);
            this.$refs.DriverEchartBox.GetDriverEcharts(e);

        },
        datepicker_company_event(e) {
            console.log('正常格式日期',e);
            this.$refs.CompanyEchartBox.GetCompanyEcharts(e);

        },
        GetOrderEchart() {
            this.$refs.OrderEchartEchartBox.GetOrderEchart();
        },
        GetInvoiceEchart() {
            this.$refs.InvoiceEchartBox.GetInvoiceEchart();
        },
        GetDriverEchart() {
            this.$refs.DriverEchartBox.GetDriverEchart();
        },
        GetCompanyEchart() {
            this.$refs.CompanyEchartBox.GetCompanyEchart();
        },
        getStatic(){
            let that = this;
            that.$axios.get('/admin/index/getStatic')
                .then(function (e) {
                    if(e.code ==0) {
                        that.basic = e.data;
                    }else{
                        that.$Message.error({ background: true,duration:3, content:e.msg});
                    }
                })
                .catch(function (e) {
                    that.$Message.error({ background: true,duration:3, content:'请求发送失败'});
                });
        },
        getStaticData(){
            let that = this;
            that.$axios.get('/admin/index/getStaticData')
                .then(function (e) {
                    if(e.code ==0) {
                        that.top_order_type_list = !!e.data.top_order_type_list ? e.data.top_order_type_list : [];
                        that.start_date = !!e.data.start_date ? e.data.start_date : '';
                        that.end_date = !!e.data.end_date ? e.data.end_date : '';
                    }else{
                        that.$Message.error({ background: true,duration:3, content:e.msg});
                    }
                })
                .catch(function (e) {
                    that.$Message.error({ background: true,duration:3, content:'请求发送失败'});
                });
        },
        collapsedSider () {
            this.$refs.side1.toggleCollapse();
        },
        HeightInit(){
            this.$store.commit('SET_TABLE_HEIGHT' , window.innerHeight);
            // 动态计算 table 的高度重新赋值
            const that = this;
            window.onresize = function () {
                that.$store.commit('SET_TABLE_HEIGHT' , window.innerHeight);
            }
        }
    }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="less" rel="stylesheet/less">
    .rx-index-box {
        width: 100%;
        position: relative;
        border: 1px solid #f6f6f6;
        background: #f6f6f6;
        border-radius: 5px;
        padding: 25px 10px;
        position: relative;
        box-shadow: 5px 5px 10px #EEE;
        cursor: pointer;
        .name {
            width: 100%;
            font-size: 15px;
            //font-weight: bold;
        }
        .box-line {
            display: flex;
            align-items: center;
            justify-content: space-between;
            padding-bottom: 15px;
            .order-count {
                font-size: 20px;
                font-weight: bold;
                display: flex;
                align-items: center;
                justify-content: center;
            }
            .order-count-small {
                font-size: 12px;
                display: flex;
                align-items: center;
                justify-content: center;
                em {
                    font-size: 16px;
                    padding-left: 10px;
                }
            }
        }
        .icons {
            position: absolute;
            bottom: 10px;
            right: 10px;
            color: rgba(40,130,255,0.1);
        }
    }
    .rx-index-card {
        margin-top: 20px;
    }
</style>



// WEBPACK FOOTER //
// src/view/home/Index.vue